import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
// import notify from '../../Notifications/ToastifyActions';
import notify from '../../../Notifications/ToastifyActions';

function UpdateNotificationSettingsService(token,data) {

    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/updateNotificationSettings`, data, {
        headers: {
            'Authorization': token,
        }
    }).then(res => {
        notify.NotifySuccess("Action Setting has been updated successfully.")
        return res.data; // Correctly return the response data
    }).catch(error => {
        console.error(error);
        notify.NotifyError("An error occurred while updating Action Setting. Please try again later.");
        return false;
    });
}

export  default UpdateNotificationSettingsService